import { render, staticRenderFns } from "./PopitItem.vue?vue&type=template&id=5e30d5af&scoped=true&"
import script from "./PopitItem.vue?vue&type=script&lang=js&"
export * from "./PopitItem.vue?vue&type=script&lang=js&"
import style0 from "./PopitItem.vue?vue&type=style&index=0&id=5e30d5af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30d5af",
  null
  
)

export default component.exports